<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" >
               
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="title"
                    label="标题" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="value"
                    label="内容" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该内容吗？" >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <EditDrawer v-if="showEdit" :item="currentBasicData"
                            @close="showEdit = false" @submit="loadData"></EditDrawer>
    </div>
</template>

<style scoped>
    .order_btn {
        display: inline-block;
        background: var(--primary);
        color: white;
        margin: 0 5px;
        cursor: pointer;
        padding: 2px;
    }
</style>
<style>

</style>

<script>

    import {mapMutations} from 'vuex';
    import EditDrawer from "./BasicDataEditDrawer";
    export default {
        components: {
           EditDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form:{
                    keywords: "",
                    type:2,
                },
                typeOption: {},
                currentBasicData: {},
                tableData: [ ],
                showEdit: false,
                editItem: {},
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
            }

        },

        watch: {
           "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            edit(item) {
                this.currentBasicData = {...item};
                this.showEdit = true;
            },
           
            del(item) {
                this.$ajaxGet("/dictionary/del/" + item.id, (data) => {
                    this.loadData();
                })
            },
            loadData() {
                this.$ajaxPost("/dictionary/listBasicData",{
                    form: this.form, 
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
        },

        created() {
            this.loadData();
        }

    }
</script>
